export const AVATAR_OUTPUT_SIZE = 768;
export const MIN_CROP_SOURCE_SIZE = 768;

export function cropZoomLimit(width, height) {
  return Math.max(1, Math.min(3, Math.min(width, height) / MIN_CROP_SOURCE_SIZE));
}

export function clampCropPosition({ x, y }, width, height, viewport, zoom) {
  const baseScale = Math.max(viewport / width, viewport / height);
  const displayedWidth = width * baseScale * zoom;
  const displayedHeight = height * baseScale * zoom;
  const maxX = Math.max(0, (displayedWidth - viewport) / 2);
  const maxY = Math.max(0, (displayedHeight - viewport) / 2);
  return {
    x: Math.max(-maxX, Math.min(maxX, x)),
    y: Math.max(-maxY, Math.min(maxY, y)),
  };
}

export function cropSourceRect(width, height, viewport, zoom, position) {
  const baseScale = Math.max(viewport / width, viewport / height);
  const scale = baseScale * zoom;
  const cropSize = viewport / scale;
  return {
    left: Math.max(0, Math.min(width - cropSize, (width - cropSize) / 2 - position.x / scale)),
    top: Math.max(0, Math.min(height - cropSize, (height - cropSize) / 2 - position.y / scale)),
    size: cropSize,
  };
}
